import { ME_QUERY_KEY } from '@/hooks/useAuth';
import { api } from '@/lib/api';
import { clearAccessToken } from '@/lib/auth';
import { clearDiscoveryEtagCache } from '@/lib/discoveries';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export function useSignOut() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async () => {
      try {
        await api.post('/auth/logout');
      } catch (err) {
        // If the token is already revoked / expired, treat logout as successful —
        // the local state matters more than a server round-trip.
        if (axios.isAxiosError(err) && err.response?.status === 401) return;
        throw err;
      }
    },
    onSettled: () => {
      clearAccessToken();
      // Module-level ETag cache survives unmount; explicitly flush on
      // sign-out so the next user on this browser cannot send a stale
      // If-None-Match with the previous session's ETag (cross-session
      // cache bleed in shared-machine / team-handoff scenarios).
      clearDiscoveryEtagCache();
      queryClient.removeQueries({ queryKey: ME_QUERY_KEY });
      navigate('/sign-in', { replace: true });
    },
  });
}
